import React from 'react';
import classNames from 'classnames';
import { useIntl } from 'react-intl';
import {
  Dialog, DialogContent, DialogFooter, DialogTitle,
} from '../../../components/base/Dialog/Dialog';
import { Button, Icons } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import CustomSelectInput from '../../../components/fields/SelectInput/CustomSelectInput';
import FieldDTO from '../../../components/fields/Abstract/FieldDTO';
import ViolationDTO from '../../../dto/ViolationDTO';
import TextInputWithLabel from '../../../components/fields/TextInput/TextInputWithLabel';
import { createClearObject } from '../../../utils/utils';
import RangeDatePicker from '../../../components/fields/RangeDatePicker/RangeDatePicker';
import {
  VEHICLE_ENTITY_TYPES_LIST,
  VIOLATION_STATUS_LIST,
  VIOLATION_TYPE_LIST,
} from '../../../configs';
import CustomSelectInputWithHelper from '../../../components/fields/SelectInput/CustomSelectInputWithHelper';
import { loadZoneList } from '../../Zones/actions';
import { loadProviderList } from '../../Provider/actions';

export default function FilterForm(props) {
  const {
    onHide, getValues, reset, defaultValues, setValue, control,
  } = props;
  const { formatMessage } = useIntl();
  const DTO = new ViolationDTO();
  const attributes = DTO.getAttributesByName();
  const clear = () => {
    const fields = getValues();
    const cleared = createClearObject(fields);
    reset({ ...cleared, ...defaultValues });
  };
  const save = () => {
    onHide();
  };

  return (
    <Dialog
      className={classNames('full-filter')}
      onClose={save}
      open
    >
      <DialogTitle header={formatMessage({ id: 'filters' })} title={<Icons onClick={onHide} customIcon icon="close" className="close" />} />
      <DialogContent className="hff-content custom-scroll-theme">
        <form className="filter-content-wrapper">
          <FieldDTO
            control={control}
            component={TextInputWithLabel}
            dtoObject={attributes.inspector_login}
            hideSmallButtons
            showArrowIcon
            usePortal
            withLabel
            variant="material"
          />
          <FieldDTO
            control={control}
            component={CustomSelectInput}
            dtoObject={attributes.type}
            usePortal
            placeholder="Тип нарушения"
            options={VIOLATION_TYPE_LIST}
            addPlaceholder
            multiple
            withLabel
            variant="material"
          />
          <FieldDTO
            control={control}
            component={CustomSelectInput}
            dtoObject={attributes.statuses}
            usePortal
            placeholder="Статус"
            options={VIOLATION_STATUS_LIST}
            addPlaceholder
            multiple
            withLabel
            variant="material"
          />
          <FieldDTO
            control={control}
            dtoObject={attributes.provider_id}
            usePortal
            addPlaceholder
            component={CustomSelectInputWithHelper}
            portalClassName="executor-selector"
            loadAction={loadProviderList}
            optionFormatter={item => ({ value: item.id, name: item.name || item.provider_name })}
            filterName="name"
            variant="material"
            withLabel
          />
          <FieldDTO
            control={control}
            dtoObject={attributes.zone_id}
            usePortal
            addPlaceholder
            component={CustomSelectInputWithHelper}
            portalClassName="executor-selector"
            loadAction={loadZoneList}
            optionFormatter={item => ({ value: item.id, name: item.name })}
            filterName="name"
            variant="material"
            withLabel
          />
          <FieldDTO
            control={control}
            component={CustomSelectInput}
            dtoObject={attributes.vehicle_type}
            usePortal
            placeholder="Тип СИМ"
            options={VEHICLE_ENTITY_TYPES_LIST}
            addPlaceholder
            multiple
            withLabel
            variant="material"
          />

          <FieldDTO
            control={control}
            component={RangeDatePicker}
            dtoObject={attributes.date}
            hideSmallButtons
            showArrowIcon
            usePortal
            placeholder="Дата создания"
            changeFormat="YYYY-MM-DD"
            withLabel
            inputProps={{
              value: [getValues('created_at_from'), getValues('created_at_to')],
              onChange: e => {
                const v = e.target.value;
                setValue('created_at_from', v[0]);
                setValue('created_at_to', v[1]);
              },
            }}
            variant="material"
          />
          <FieldDTO
            control={control}
            component={RangeDatePicker}
            dtoObject={attributes.updated_at}
            hideSmallButtons
            showArrowIcon
            usePortal
            placeholder="Дата обновления"
            changeFormat="YYYY-MM-DD"
            withLabel
            inputProps={{
              value: [getValues('updated_at_from'), getValues('updated_at_to')],
              onChange: e => {
                const v = e.target.value;
                setValue('updated_at_from', v[0]);
                setValue('updated_at_to', v[1]);
              },
            }}
            variant="material"
          />
        </form>
      </DialogContent>
      <DialogFooter className="hff-footer">
        {/* <div className="hff-footer-text">{formatMessage({ id: 'find' }, { count: meta.count })}</div> */}
        <div className="hff-footer-buttons hff-center">
          {/* <Button className="hff-clear-show" onClick={save}>{formatMessage({ id: 'show' })}</Button> */}
          <Button className="hff-clear-data" variant="secondary" onClick={clear}>{formatMessage({ id: 'clear.all' })}</Button>
        </div>
      </DialogFooter>
    </Dialog>
  );
}
